module.exports = __webpack_public_path__ + "img/medc-dots.00df6378.svg";